const FEATURES = [
  {
    icon: 'ri-book-read-line',
    title: '海量正版漫画',
    desc: '汇聚2000+部甜宠恋爱、校园纯爱、少女漫画，日漫韩漫一网打尽，持续更新中。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '完全免费阅读',
    desc: '所有漫画作品全部免费阅读，无需付费订阅，让甜蜜故事触手可及。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '每日稳定更新',
    desc: '热门连载每日更新，同步追更不等待，第一时间享受最新甜蜜剧情。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '沉浸阅读体验',
    desc: '精心优化的移动阅读界面，流畅翻页，智能适配各种屏幕，随时随地甜蜜阅读。',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: '智能推荐引擎',
    desc: '根据你的阅读喜好精准推荐甜蜜漫画，发现更多让你心动的恋爱故事。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="section-padding bg-background-100">
      <div className="section-container">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            平台特色
          </h2>
          <p className="text-foreground-600 mt-2 text-sm md:text-base">为什么选择甜柚漫画</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {FEATURES.map((f, idx) => (
            <div
              key={idx}
              className="p-6 rounded-2xl bg-background-50 border border-background-200/70 text-center hover:border-primary-200 transition-all duration-200 group"
            >
              <div className="w-14 h-14 mx-auto rounded-2xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${f.icon} text-primary-500 text-2xl`}></i>
              </div>
              <h3 className="text-base font-bold text-foreground-900 mb-2">{f.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}